import React from "react";

// `lang` is specified on load
// `locale` is loaded initially
// There is no language change within the application for now
export const I18nContext = React.createContext({
  lang: "",
  locale: {},
});
